<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  [bodyClass]="input_isModalMode ? 'tw-p-3' : 'tw-pt-3 tw-pl-3  tw-pr-5'"
  (onAdd)="onCreate('', true)"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- title -->
        <td>
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>

        <!-- isPublicTemplate -->
        <td>
          <td-value type="boolean" [value]="item?.isPublicTemplate"></td-value>
        </td>

        <!-- templatePreview -->
        <td [style.width.px]="'100'">
          <app-show-images
            class="tw-mt-1"
            imgHeight="100px"
            [src]="item.templatePreview"
          ></app-show-images>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <!-- table operation  -->
        <td class="sticky-td">
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!--*select btn -->
            <div
              app-menu-btn
              icon="mdi-text-box-plus-outline mdi-18px"
              color="blue"
              title="common.select"
              (click)="onSelect(item)"
            ></div>

            <!--*copy btn -->
            <!-- <div
              app-menu-btn
              icon="mdi-content-copy mdi-18px"
              color="info"
              title="common.copy"
              (click)="copyReadyTemplate(item.id)"
            ></div> -->

            <!-- *edit btn -->
            <!-- <div app-menu-btn icon="edit" (click)="onUpdate(item.id)"></div> -->

            <!-- *delete btn -->
            <div
              app-menu-btn
              icon="delete"
              (click)="onDelete(item.id, item.title)"
            ></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------- Audit ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
